import { render, staticRenderFns } from "./QuickActionToggleButton.vue?vue&type=template&id=c2c6edb2&scoped=true&lang=pug&"
import script from "./QuickActionToggleButton.vue?vue&type=script&lang=js&"
export * from "./QuickActionToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./QuickActionToggleButton.vue?vue&type=style&index=0&id=c2c6edb2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c6edb2",
  null
  
)

export default component.exports